(() => {
  const button = document.getElementById('BackToTop');
  if (!button) return;

  const SHOW_AFTER_PX = 4200;
  const revealSection = document.querySelector('.ugc-reviews');

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  if (revealSection) {
    // Show as soon as this section (the "Loved By Busy People" reviews
    // carousel) starts entering the viewport, rather than an arbitrary
    // scroll distance - stays accurate even if earlier sections change
    // height. isIntersecting alone would flip back to false once the
    // section is fully scrolled past, so top < 0 keeps it shown for the
    // rest of the page too; only hides again if scrolled back above it.
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          button.classList.toggle('is-visible', entry.isIntersecting || entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    ).observe(revealSection);
    return;
  }

  // Fallback for templates without that section (e.g. product pages): a
  // flat scroll distance.
  let ticking = false;

  const updateVisibility = () => {
    button.classList.toggle('is-visible', window.scrollY > SHOW_AFTER_PX);
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateVisibility);
    },
    { passive: true }
  );

  updateVisibility();
})();
